import { render, staticRenderFns } from "./FrequentlyAskedQuestionsConfirm.vue?vue&type=template&id=1fb1683a&scoped=true&"
import script from "./FrequentlyAskedQuestionsConfirm.vue?vue&type=script&lang=ts&"
export * from "./FrequentlyAskedQuestionsConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./FrequentlyAskedQuestionsConfirm.vue?vue&type=style&index=0&id=1fb1683a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb1683a",
  null
  
)

export default component.exports